export const STATIC_HOST_3 = "https://tiktok.fullstack.edu.vn/api/"; //api filter products

export const THUMBNAIL_PLACEHOLDER = "https://via.placeholder.com/444"; //api handle object null

export const STATIC_HOST_2 = "https://linkking.onrender.com/api/v1";

export const STATIC_HOST_4 = "https://linkking.onrender.com/api/v1";
